import { render, staticRenderFns } from "./localization.vue?vue&type=template&id=22e9c1f7"
import script from "./localization.vue?vue&type=script&lang=js"
export * from "./localization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports